import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-color-preview',
  templateUrl: './color-preview.component.html',
  styleUrls: ['./color-preview.component.css'],
})
export class ColorPreviewComponent implements OnInit {
  @Input() colorCode: string = '';
  @Input() showSkeleton: boolean = true;

  constructor() {}

  ngOnInit(): void {}
}
